import BusinessHome from './home/BusinessHome'
import EducationHome from './home/EducationHome'
import EntertenmentHome from './home/EntertenmentHome'
import ImportantNews from './home/ImportantNews'
import InternationalHome from './home/InternationalHome'
import LatestVideos from './home/LatestVideos'
import SportsHome from './home/SportsHome'

function HomePage() {
  return (
    <div>
      <ImportantNews />
      <LatestVideos />
      <BusinessHome />
      <SportsHome />
      <InternationalHome />
      <EntertenmentHome />
      <EducationHome />
    </div>
  )
}

export default HomePage